import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import DocumentLink from '../../DocumentLink';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class PoliticaInvestimento extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"politica-investimentos"} page={'politica-investimentos'}></InfoComponent>

					{/* Content page */}
					<div className="_the-content page-planos pb-10">
						<div className='container'>
							<div className="row justify-content-center">

								<div className="col-md-10">
									<div className="row">

										<ErrorBoundary><DocumentLink url={'ObterPoliticainvestimentos'} fileImg={'../../assets/img/Política de Investimentos_Prancheta 1.png'} /></ErrorBoundary>

										{/* 
                <div className="row justify-content-center">
					<div className="col-md-10">
						<div className="row">
							<div className="col-md-6">
								<a href="#" className="box-pdf mt-6 mb-4 d-block" target="_blank">
									<img src={imgOrg} alt="Organograma" className="mb-5"/>

									<span> <strong>  Política de investimentos  </strong> </span> <br/>
									<span className="d-flex w-100 align-items-center my-4" >
										<span className="ico">
											<img src={icoPDf} alt="Pdf"/>
										</span>
										<span className="text ml-3">
											Nome do arquivo - 3,63MB
										</span>
									</span>
								</a>
							</div>
						</div>
					</div>
                </div>
			*/}
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default PoliticaInvestimento;